/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-bind */

// prop-type is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MaterialTablePicker from "components/MaterialTablePicker";
import { createRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import setAlert from "store/actions/alertActions";
import {
  removeTrend,
  clearErrors,
  // , getTrends
} from "store/actions/uniqueExperienceActions";

const UniqueExperiencesList = ({ list = {}, data = [], loading }) => {
  const dispatch = useDispatch();
  const tableRef = createRef();

  const user = useSelector((state) => state.users.user);
  const error = useSelector((state) => state.trends.error);
  // const added = useSelector((state) => state.trends.added);

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (error) {
      dispatch(setAlert(error, "error"));
      dispatch(clearErrors());
    }
  }, [error, setAlert]);
  // useEffect(() => {
  //   if (added) dispatch(getTrends(selectedDestination));
  // }, [added]);

  useEffect(() => {
    setTableData(data);
  }, [data]);

  const deleteUniqueExperienceFn = (id) => {
    const uniqueExpToBeDeleted = tableData.find((trend) => trend._id === id);
    if (uniqueExpToBeDeleted) {
      dispatch(
        removeTrend({
          id,
          type: uniqueExpToBeDeleted.type === "ticket" ? "item" : uniqueExpToBeDeleted.type,
        })
      );
    }
  };

  return (
    <MDBox>
      <MaterialTablePicker
        key={tableData?.length}
        screen={list.screen}
        title={list.title}
        tableRef={tableRef}
        onSearchChange
        columns={list.columns}
        filteringOptions={false}
        data={tableData}
        isLoading={loading}
        isExportable={false}
        editableDelete={(oldData, t, p) => deleteUniqueExperienceFn(oldData, t, p)}
        deleteRoleAction
        currentUrl="uniqueExperiences"
        addUrl="uniqueExperiences/new-uniqueExperience"
        editableRole={user.role === "admin"}
        isRowClickable={false}
        // actionsOnClick={() => handleClickOpen()}
        actionsRole={user.role === "admin"}
      />
    </MDBox>
  );
};

// typechecking props for UniqueExperiencesList
UniqueExperiencesList.propTypes = {
  list: PropTypes.instanceOf(Object),
  data: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  loading: PropTypes.bool.isRequired,
};

export default UniqueExperiencesList;
